"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseContext = void 0;
var react_1 = require("react");
exports.CollapseContext = react_1.createContext({
    activeIds: [],
    onActive: function () { return null; },
});
//# sourceMappingURL=CollapseContext.js.map